import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const mapStateToProps = ({ releases }) => ({ releases });

@connect(
	mapStateToProps,
	null
)
export default class Home extends React.Component {
	static propTypes = {}

	componentDidMount() {}

	render() {
		return <div>Hi!</div>;
	}
}
